/**
 * Merged-row cache for Bulk Operations tabs (campaigns → ad groups → keywords → …).
 * Survives tab switches; manual Refresh bypasses via forceRefresh in the hook.
 */

const store = new Map();
const BULK_LEVEL_TTL_MS = 45 * 60 * 1000;

export const BULK_OPERATION_LEVELS = [
  'campaigns',
  'adGroups',
  'keywords',
  'searchTerms',
  'products',
  'negativeKeywords',
];

function cacheKey(profileId, startDate, endDate, level) {
  const levelKey = level === 'searchTerms' ? `${level}|st-kw-v2` : level;
  return `${profileId}|${startDate}|${endDate}|${levelKey}`;
}

export function getBulkLevelCache(profileId, startDate, endDate, level) {
  if (!profileId || !level) return null;
  const key = cacheKey(profileId, startDate, endDate, level);
  const entry = store.get(key);
  if (!entry) return null;
  if (Date.now() > entry.expiresAt) {
    store.delete(key);
    return null;
  }
  return entry.data;
}

export function setBulkLevelCache(profileId, startDate, endDate, level, data) {
  if (!profileId || !level) return;
  const key = cacheKey(profileId, startDate, endDate, level);
  store.set(key, {
    data: Array.isArray(data) ? data : [],
    expiresAt: Date.now() + BULK_LEVEL_TTL_MS,
    updatedAt: Date.now(),
  });
}

export function invalidateBulkLevelCache(profileId, startDate, endDate, levels = BULK_OPERATION_LEVELS) {
  if (!profileId) return;
  const prefix = `${profileId}|`;
  for (const key of [...store.keys()]) {
    if (!key.startsWith(prefix)) continue;
    if (startDate && endDate) {
      const level = key.split('|').pop();
      if (!levels.includes(level)) continue;
      if (!key.includes(`|${startDate}|${endDate}|`)) continue;
    }
    store.delete(key);
  }
}

export function clearBulkOperationsCache() {
  store.clear();
}
